<template>
  <div class="columns is-mobile">
    <div class="column">
      <div class="columns">
        <div class="column">
          <b-field
            label="First Name"
            :type="{'is-danger': errors.has('employee.iw_firstname')}"
            :message="errors.first('employee.iw_firstname')"
            expanded
          >
            <b-input
              v-model="fnoldata.employee.firstName"
              name="iw_firstname"
              v-validate="'required|alpha_spaces'"
              data-vv-as="First Name"
              data-vv-scope="employee"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Last name"
            :type="{'is-danger': errors.has('employee.iw_lastname')}"
            :message="errors.first('employee.iw_lastname')"
            expanded
          >
            <b-input
              v-model="fnoldata.employee.lastName"
              name="iw_lastname"
              v-validate="'required|alpha_spaces'"
              data-vv-as="Last Name"
              data-vv-scope="employee"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Middle Initial"
            :type="{'is-danger': errors.has('iw_middleInitials')}"
            :message="errors.first('iw_middleInitials')"
            expanded
          >
            <b-input v-model="fnoldata.employee.middleInitials" name="iw_middleInitials" />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            label="Social security #"
            :type="{'is-danger': errors.has('employee.iw_ssn')}"
            :message="errors.first('employee.iw_ssn')"
          >
            <b-input
              v-model="iwSocalSecurity"
              name="iw_ssn"
              v-validate="'required|min:11'"
              data-vv-as="Social Security"
              data-vv-scope="employee"
              maxlength="11"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Birth date"
            :type="{'is-danger': errors.has('employee.iw_birthdate')}"
            :message="errors.first('employee.iw_birthdate')"
            expanded
          >
            <b-datepicker
              placeholder="Select a date..."
              icon="calendar-today"
              name="iw_birthdate"
              v-model="fnoldata.employee.dateOfBirth"
              v-validate="'required'"
              data-vv-as="Birth date"
              :max-date="maxDate"
              data-vv-scope="employee"
            >
              <button class="button is-warning" @click="fnoldata.employee.dateOfBirth = new Date()">
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
              </button>

              <button class="button is-warning" @click="fnoldata.employee.dateOfBirth = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
          <span
            class="dob-span"
            style="color:#FF0000;font-size: 11pt; font-family:arial"
          >{{this.dobValidate}}</span>
        </div>
      </div>
      <b-field
        label="Mailing address"
        :type="{'is-danger': errors.has('employee.iw_mailingaddress')}"
        :message="errors.first('employee.iw_mailingaddress')"
      >
        <b-input
          v-model="fnoldata.employee.address.street"
          name="iw_mailingaddress"
          v-validate="'required'"
          data-vv-as="Address"
          data-vv-scope="employee"
        />
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field
            label="City"
            :type="{'is-danger': errors.has('employee.iw_city')}"
            :message="errors.first('employee.iw_city')"
            expanded
          >
            <b-input
              v-model="fnoldata.employee.address.city"
              name="iw_city"
              v-validate="'required'"
              data-vv-as="City"
              data-vv-scope="employee"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="State"
            :type="{'is-danger': errors.has('employee.iw_state')}"
            :message="errors.first('employee.iw_state')"
          >
            <b-select
              v-model="fnoldata.employee.address.state"
              placeholder="Please select"
              name="iw_state"
              v-validate="'required'"
              data-vv-as="State"
              data-vv-scope="employee"
              expanded
            >
              <option v-for="(key, value) in stateMap" :value="value" :key="value">{{ key }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Zip code"
            :type="{'is-danger': errors.has('employee.iw_zipcode')}"
            :message="errors.first('employee.iw_zipcode')"
          >
            <b-input
              v-model="fnoldata.employee.address.zip"
              name="iw_zipcode"
              v-validate="{ required: true, regex:/^\d{5}(-\d{4})?$/ }"
              data-vv-as="Zip code"
              data-vv-scope="employee"
              maxlength="10"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            label="Phone"
            :type="{'is-danger': errors.has('employee.phone')}"
            :message="errors.first('employee.phone')"
            expanded
          >
            <b-input
              v-model="employeePhone"
              name="phone"
              v-validate="'min:16'"
              data-vv-as="Phone"
              data-vv-scope="employee"
              maxlength="16"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Gender" expanded>
            <b-select v-model="fnoldata.employee.gender" placeholder="Select Gender" expanded>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="U">Unknown</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Date of hire" expanded>
            <b-datepicker
              placeholder="Select a date..."
              icon="calendar-today"
              v-model="fnoldata.employment.dateOfHiring"
            >
              <button
                class="button is-warning"
                @click="fnoldata.employment.dateOfHiring = new Date()"
              >
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
              </button>
              <button class="button is-warning" @click="fnoldata.employment.dateOfHiring = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
          <span
            class="doh-span"
            style="color:#FF0000;font-size: 11pt; font-family:arial"
          >{{this.dohValidate}}</span>
        </div>
      </div>
      <b-field
        label="Occupation"
        :type="{'is-danger': errors.has('employee.iw_occupation')}"
        :message="errors.first('employee.iw_occupation')"
        expanded
      >
        <b-input
          v-model="fnoldata.employment.occupation"
          name="iw_occupation"
          v-validate="'required'"
          data-vv-as="Occupation"
          data-vv-scope="employee"
        />
      </b-field>
      <br />
      <b-field
        label="Employment status"
        :addons="false"
        :type="{'is-danger': errors.has('employmentstatus')}"
        :message="errors.first('employmentstatus')"
      >
        <b-radio
          v-model="fnoldata.employment.employmentStatus"
          name="employmentstatus"
          native-value="F"
        >Regular Full-Time</b-radio>
        <b-radio
          v-model="fnoldata.employment.employmentStatus"
          name="employmentstatus"
          native-value="P"
        >Part-Time</b-radio>
        <b-radio
          v-model="fnoldata.employment.employmentStatus"
          name="employmentstatus"
          native-value="T"
        >Temporary</b-radio>
        <b-radio
          v-model="fnoldata.employment.employmentStatus"
          name="employmentstatus"
          native-value="S"
        >Seasonal</b-radio>
      </b-field>
      <br />
      <b-field label="Employee usual work hours?"></b-field>
      <div class="columns">
        <div class="column">
          <b-field
            label="Hours per day worked"
            :type="{'is-danger': errors.has('employee.iw_hoursperday')}"
            :message="errors.first('employee.iw_hoursperday')"
          >
            <b-input
              v-model="fnoldata.employment.hoursPerDay"
              name="iw_hoursperday"
              data-vv-as="Hours per day"
              v-validate="'required|between:1,24'"
              data-vv-scope="employee"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Days per week"
            :type="{'is-danger': errors.has('employee.iw_daysperweek')}"
            :message="errors.first('employee.iw_daysperweek')"
            expanded
          >
            <b-input
              v-model="fnoldata.employment.daysPerWeek"
              name="iw_daysperweek"
              v-validate="'required|between:1,7'"
              data-vv-as="Days per week"
              maxlength="1"
              data-vv-scope="employee"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="Total weekly hours?"
            :type="{'is-danger': errors.has('employee.totalweeklyhours')}"
            :message="errors.first('employee.totalweeklyhours')"
            expanded
          >
            <b-input
              v-model="fnoldata.employment.totalWeeklyHours"
              name="totalweeklyhours"
              disabled
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            label="Gross wages/salary ($)"
            :type="{'is-danger': errors.has('employee.iw_GrossWages')}"
            :message="errors.first('employee.iw_GrossWages')"
            expanded
          >
            <b-input
              v-model="fnoldata.employment.grossWages"
              name="iw_GrossWages"
              v-validate="'decimal'"
              data-vv-as="Gross wages"
              data-vv-scope="employee"
              maxlength="10"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Pay Period" expanded>
            <b-select
              placeholder="Please select"
              v-model="fnoldata.employment.grossWagePer"
              expanded
            >
              <option value="Hour">Hour</option>
              <option value="Day">Day</option>
              <option value="Week">Week</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <b-field label="Other wages reported? (eg. Tips, meals, lodging, bonus..)">
        <b-switch
          v-model="fnoldata.employment.opy"
          true-value="Yes"
          false-value="No"
        >{{ fnoldata.employment.opy }}</b-switch>
      </b-field>
    </div>
  </div>
</template>
<script>
import TypeLists from "../data/typelists";
import { PhoneFormatter, SSNFormatter, ZipFormatter } from "../utils/util";

export default {
  props: ["fnoldata"],
  name: "EmployeeInfo",
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator;
  },
  data() {
    const today = new Date();
    return {
      workPhone: "",
      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      stateMap: TypeLists.StatesFiltered,
      iwSocalSecurity: SSNFormatter(this.fnoldata.employee.ssn),
      dobValidate: '',
      dohValidate: '',
      employeePhone: PhoneFormatter(this.fnoldata.employee.phone.mobile)
    };
  },

  watch: {
    iwSocalSecurity: function(input) {
      //alert(input);
      input = SSNFormatter(input);
      this.iwSocalSecurity = input;
      this.fnoldata.employee.ssn = input.replace(/[^\d.]/g, "");
    },
    "fnoldata.employment.daysPerWeek": function(val) {
      if (this.fnoldata.employment.daysPerWeek > 7) {
        //alert("Days per week cannot be greater than 7 days!");
      } else {
        this.fnoldata.employment.totalWeeklyHours = (
          this.fnoldata.employment.daysPerWeek *
          this.fnoldata.employment.hoursPerDay
        ).toFixed(2);
      }
    },
    "fnoldata.employment.hoursPerDay": function(val) {
      if (this.fnoldata.employment.hoursPerDay > 24) {
        // alert("Hours per day cannot be greater than 24 hours!");
      } else {
        // this.fnoldata.employment.hoursPerDay =  pointNumber.toFixed(2);
        this.fnoldata.employment.totalWeeklyHours = (
          this.fnoldata.employment.daysPerWeek *
          this.fnoldata.employment.hoursPerDay
        ).toFixed(2);
      }
    },
    "fnoldata.employment.grossWages": function(val) {
      this.fnoldata.employment.GrossWages = val.toFixed(2);
    },

     "fnoldata.employee.dateOfBirth": function(input){
       var injuredDate = this.fnoldata.injury.dateOfInjury;
       var date = new Date();
       console.log("today's date is ", date);
       console.log("injured date is : ", injuredDate);
       if(input){
        if(input > injuredDate){
         console.log("input > injuredDate is false", (input > injuredDate));
         this.dobValidate = "Date Of Birth Cannot be greater than Date of Injury";
       } else{
         this.dobValidate = "";
       }
       }else{
         this.dobValidate = "";
       }
     },

     "fnoldata.employment.dateOfHiring": function(input){
       var dateOfBirth = this.fnoldata.employee.dateOfBirth;
       var dateOfInjury = this.fnoldata.injury.dateOfInjury;
       if(input){
       if(input < dateOfBirth){
         console.log("date of injury is" , input);
          this.dohValidate = "Date Of Hire Cannot be less than the Date of Birth";
       }else if(input > dateOfInjury){
          this.dohValidate = "Date Of Hire Cannot be greater than the Date of Injury.";
       }else{
         this.dohValidate = "";
       }
       }else{
         this.dohValidate = "";
       }
     },

    "fnoldata.employee.address.zip": function(input) {
      input = ZipFormatter(input);
      this.fnoldata.employee.address.zip = input;
    },

    employeePhone: function(input) {
      //alert(input);
      input = PhoneFormatter(input);
      this.employeePhone = input;
      this.fnoldata.employee.phone.mobile = input.replace(/[^\d.]/g, "");
    }
  }
};
</script>

